/**
 * @generated SignedSource<<e07700ca50994f4d4ef3b958f8186eb6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type nav_CelloReferralFragment_viewer$data = {
  readonly celloUserToken: string | null;
  readonly user: {
    readonly email: string;
    readonly firstName: string;
    readonly fullName: string;
    readonly lastName: string;
  };
  readonly " $fragmentType": "nav_CelloReferralFragment_viewer";
};
export type nav_CelloReferralFragment_viewer$key = {
  readonly " $data"?: nav_CelloReferralFragment_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"nav_CelloReferralFragment_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": require('./nav_CelloReferralFragment_viewer_refetchCelloUserToken.graphql')
    }
  },
  "name": "nav_CelloReferralFragment_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "celloUserToken",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fullName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "4ebde031fce6bf559db49d114356b205";

export default node;
